import * as Yup from "yup";

// Contact info (used in pickup + delivery forms)
export const contactInfoSchema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  phone: Yup.string()
    .required("Phone is required")
    .matches(/^[0-9]{10,15}$/, "Phone number must be 10–15 digits"),
  companyName: Yup.string().required("Company name is required"),
  taxId: Yup.string().required("Tax Id is required"),
});

// Address schema
export const addressSchema = Yup.object({
  country: Yup.string().required("Country is required"),
  state: Yup.string().required("State/Province is required"),
  city: Yup.string().required("City is required"),
  postcode: Yup.string().required("Postcode is required"),
  addressLine1: Yup.string().required("Address Line 1 is required"),
  addressLine2: Yup.string().optional(),
});

// Location info used in all 3 forms
export const locationDetailsSchema = Yup.object({
  locationType: Yup.string().required("Location type is required"),
  forklifAvailable: Yup.boolean(),
  assistanceAvailable: Yup.boolean(),
  specialNotes: Yup.string().when("assistanceAvailable", {
    is: true,
    then: (schema) => schema.required("Special assistance notes are required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

// Transport documents
export const transportDocumentsSchema = Yup.object({
  deliveryNote: Yup.array()
    .min(1, "Please upload Delivery Note")
    .required("Delivery Note Required"),
  packingList: Yup.array()
    .min(1, "Please upload Packing List")
    .required("Packing List Required"),
  weightSlip: Yup.array()
    .min(1, "Please upload Weight Slip")
    .required("Weight Slip Required"),
  invoice: Yup.array().min(1, "Please upload Invoice").required("Invoice is Required"),
  consignmentNote: Yup.array()
    .min(1, "Please upload Consignment Note")
    .required("Consignment Note Required"),
  manifest: Yup.array().min(1, "Please upload Manifest").required("Manifest is Required"),
});
